export const WHAT_TO_DO = "What would you like to build today?";
export const APP_GENERATION_IS_COMPLETE = "App generation is complete";
export const TRY_THESE_EXAMPLE_STARTER_PROMPTS = "Try these example starter prompts";
export const TRY_ANOTHER_PROMPT = "Try another prompt";
